import { Slider } from "@/components/ui/slider";
import { FIELDS, GROUPS } from "@/lib/finance";
import { usd, pct, num } from "@/lib/format";

const show = (f, v) => (f.type === "currency" ? usd(v) : f.type === "pct" ? pct(v) : num(v));

function Field({ f, value, onChange, prefix }) {
  const v = Number(value) || 0;
  return (
    <div className="py-3 border-b border-dashed border-[#E2DCD2] last:border-0">
      <div className="flex items-center justify-between gap-3">
        <label htmlFor={`${prefix}-${f.key}`} className="text-[0.8rem] font-medium text-slate-700">{f.label}</label>
        <div className="flex items-center gap-1">
          {f.type === "currency" && <span className="text-xs text-slate-400">$</span>}
          <input
            id={`${prefix}-${f.key}`} type="number" step={f.step} value={value} min={0}
            onChange={(e) => onChange(f.key, e.target.value === "" ? 0 : Number(e.target.value))}
            onBlur={() => {
              const max = f.type === "pct" ? Math.max(f.max, 100) : Infinity;
              const c = Math.min(Math.max(v, f.type === "int" ? f.min : 0), f.key === "occupancy" ? 100 : max);
              if (c !== v) onChange(f.key, c);
            }}
            className="w-32 h-8 rounded border border-[#E2DCD2] bg-white px-2 text-right font-mono-num text-xs focus:outline-none focus:border-[#C59B27]"
            data-testid={`${prefix}-input-${f.key}`}
          />
          {f.type === "pct" && <span className="text-xs text-slate-400">%</span>}
        </div>
      </div>
      <div className="flex items-center gap-3 mt-2">
        <Slider value={[Math.min(Math.max(v, f.min), f.max)]} min={f.min} max={f.max} step={f.step} onValueChange={([x]) => onChange(f.key, x)} data-testid={`${prefix}-slider-${f.key}`} />
        <span className="w-24 text-right font-mono-num text-[0.7rem] text-[#3E5C4E]">{show(f, v)}</span>
      </div>
    </div>
  );
}

export default function FinancialForm({ values, onChange, prefix = "calc" }) {
  const set = (k, v) => onChange({ ...values, [k]: v });
  return (
    <div className="space-y-5" data-testid={`${prefix}-form`}>
      {GROUPS.map((g) => (
        <section key={g.id} className="paper rounded-lg p-4 sm:p-5" data-testid={`${prefix}-group-${g.id}`}>
          <p className="eyebrow mb-1">{g.label}</p>
          {FIELDS.filter((f) => f.group === g.id).map((f) => (
            <Field key={f.key} f={f} value={values[f.key]} onChange={set} prefix={prefix} />
          ))}
        </section>
      ))}
    </div>
  );
}
